import React from "react";
import { Form, Checkbox, Radio, Input, Row, Col, DatePicker } from "antd";
import "../BusinessSignupForm.css";
import moment from "moment";

const Section6 = ({ formValues, setFormValues }) => {
  const renderCheckboxGrid = (options, value, onChange) => (
    <Checkbox.Group
      value={value || []}
      onChange={onChange}
      style={{ width: "100%" }}
    >
      <Row gutter={[0, 8]}>
        {options.map((item) => (
          <Col span={12} key={item}>
            <Checkbox value={item}>{item}</Checkbox>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  );

  return (
    <Form layout="vertical">
      <h2 style={{ marginBottom: "20px", color: "#333" }}>
        Section 6 – Tools, Assets & Positioning
      </h2>

      {/* Q22 – Marketing Tools / Assets */}
      <Form.Item label="22. What marketing tools or assets do you currently have? (Check all that apply)">
        {renderCheckboxGrid(
          [
            "Business cards",
            "Brochures or flyers",
            "Pamphlets",
            "Website",
            "Landing page",
            "Facebook account",
            "Instagram account",
            "YouTube channel",
            "Other",
            "None / Not applicable",
          ],
          formValues.marketingAssets,
          (checked) =>
            setFormValues({ ...formValues, marketingAssets: checked })
        )}

        {/* If "Other" is selected */}
        {formValues.marketingAssets?.includes("Other") && (
          <Input
            placeholder="Please specify other tools or assets"
            style={{ marginTop: 8 }}
            value={formValues.marketingAssetsOther || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                marketingAssetsOther: e.target.value,
              })
            }
          />
        )}
      </Form.Item>

      {/* Q23 – Are tools/assets up to date? */}
      <Form.Item label="23. Are your current tools/assets up to date?">
        <Radio.Group
          value={formValues.assetsStatus}
          onChange={(e) =>
            setFormValues({ ...formValues, assetsStatus: e.target.value })
          }
        >
          <Radio value="Yes – Everything is current">
            Yes – Everything is current
          </Radio>
          <Radio value="Some – Some are updated, others need revisions">
            Some are updated, others need revisions
          </Radio>
          <Radio value="No – Most or all need updates">
            No – Most or all need updates
          </Radio>
        </Radio.Group>
      </Form.Item>

      {/* If updates are needed → ask when last updated */}
      {(formValues.assetsStatus ===
        "Some – Some are updated, others need revisions" ||
        formValues.assetsStatus === "No – Most or all need updates") && (
        <Form.Item label="When did you last update these materials? (Approximate date or timeframe)">
          <DatePicker
            style={{ width: "100%" }}
            format="MM/DD/YYYY"
            value={
              formValues.lastUpdatedAssets
                ? moment(formValues.lastUpdatedAssets, "MM/DD/YYYY")
                : null
            }
            onChange={(d) =>
              setFormValues({
                ...formValues,
                lastUpdatedAssets: d ? d.format("MM/DD/YYYY") : "",
              })
            }
          />
        </Form.Item>
      )}

      {/* Q24 – Business Highlights */}
      <Form.Item label="24. What’s most important for people to know about your business? (Select all that apply)">
        {renderCheckboxGrid(
          [
            "Locally owned & community-focused",
            "Affordable products/services",
            "High-quality or premium offerings",
            "Experienced & trusted in our industry",
            "New & growing",
            "Unique or niche specialization",
            "Excellent customer service",
            "We serve a specific cultural/language group",
            "Other",
          ],
          formValues.businessHighlights,
          (checked) =>
            setFormValues({ ...formValues, businessHighlights: checked })
        )}

        {/* If "Other" is selected */}
        {formValues.businessHighlights?.includes("Other") && (
          <Input
            placeholder="Please specify other highlights"
            style={{ marginTop: 8 }}
            value={formValues.businessHighlightsOther || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                businessHighlightsOther: e.target.value,
              })
            }
          />
        )}
      </Form.Item>
    </Form>
  );
};

export default Section6;
